/**
 * Generate a new opaque id. URL-safe, globally unique.
 *
 * Uses `globalThis.crypto.randomUUID`, available in Node 19+ and all modern
 * browsers. No bundler-hostile `node:crypto` import.
 */
export function newId(): string {
  return globalThis.crypto.randomUUID();
}

/** Type guard: is the value a non-empty string id? */
export function isId(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0;
}
